import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import * as actions from '../../../services/actions';
import styles from './FormulaireSelectionGraphe.module.scss';

const FormulaireSelectionGraphe = ({
  preconfigurerGrapheId,
  gererGrapheId,
  affichageProfil,
}) => {
  const dispatch = useDispatch();

  // Redux state
  const listeGraphes = useSelector((state) => state.graphe.graphs_list);
  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );

  // Local state
  const [grapheId, setGrapheId] = useState(null);
  const [affichageIdName, setAffichageIdName] = useState(
    checkMot('selectionne_un_graphe')
  );

  // Effect for initial setup and preconfigured graph
  useEffect(() => {
    if (preconfigurerGrapheId) {
      setGrapheId(preconfigurerGrapheId);
    }
  }, [preconfigurerGrapheId, listeGraphes]);

  // Effect for fetching graphs list when filter changes
  useEffect(() => {
    dispatch(actions.reqRecupererListeGraphes(filtre_projects_list_id));
  }, [dispatch, filtre_projects_list_id]);

  // Handle graph selection
  const handleGrapheId = (event) => {
    const newGrapheId = parseInt(event.target.value);
    let newGrapheComponent = [];

    if (
      newGrapheId === -1 ||
      newGrapheId === null ||
      newGrapheId === '' ||
      isNaN(newGrapheId)
    ) {
      setGrapheId(null);
      setAffichageIdName(checkMot('selectionne_un_graphe'));
    } else {
      const selectedGraphe = listeGraphes.find(
        (graphe) => parseInt(graphe.graph_id) === newGrapheId
      );

      if (selectedGraphe) {
        const grapheName = selectedGraphe.graph_name;
        newGrapheComponent = grapheName;
        setGrapheId(newGrapheId);
        setAffichageIdName(grapheName);
      }
    }

    gererGrapheId(newGrapheId, newGrapheComponent);
  };

  return (
    <div className={[s.col_12].join(' ')}>
      <span className={[styles.stil2].join(' ')}>{checkMot('graph_id')}</span>
      <div className={[s.input_group, s.mb_2].join(' ')}>
        <div className={[s.input_group_prepend, styles.CaseInput].join(' ')}>
          <div
            className={[s.input_group_text, s.form_control, styles.Input].join(
              ' '
            )}
          >
            {affichageIdName}
          </div>
        </div>

        <input
          list="brow"
          className={[s.form_control].join(' ')}
          onChange={handleGrapheId}
          value={grapheId || ''}
          disabled={affichageProfil === true}
        />
        <datalist id="brow" className={[styles.datalist].join(' ')}>
          <option disabled={true} value="">
            {checkMot('selectionne_un_graphe')}
          </option>
          {listeGraphes.map((graphe) => (
            <option
              key={graphe.graph_id}
              value={graphe.graph_id}
              selected={preconfigurerGrapheId === graphe.graph_id}
            >
              {graphe.graph_name}
            </option>
          ))}
        </datalist>
      </div>
    </div>
  );
};

export default FormulaireSelectionGraphe;
